import { DatingIntention } from "@greenflagdate/shared";
import { Image, ImageProps } from "@chakra-ui/react";
import fire from "./images/fire.png";
import heart from "./images/heart.png";
import heartLightning from "./images/heartLightning.png";
import leaf from "./images/leaf.png";
import lock from "./images/lock.png";
import magnifyingGlass from "./images/magnifyingGlass.png";

const datingIntentionIconMap = {
  [DatingIntention.LifePartner]: lock,
  [DatingIntention.LongTerm]: heart,
  [DatingIntention.LongTermOpenToShortTerm]: heartLightning,
  [DatingIntention.ShortTerm]: fire,
  [DatingIntention.ShortTermOpenToLongTerm]: leaf,
  [DatingIntention.FiguringOutDatingGoals]: magnifyingGlass,
};

interface DatingIntentionIconProps extends Omit<ImageProps, "src" | "alt"> {
  intention: DatingIntention;
}

export const DatingIntentionIcon = ({
  intention,
  ...props
}: DatingIntentionIconProps) => (
  <Image
    display="block"
    src={datingIntentionIconMap[intention]}
    alt=""
    {...props}
  />
);
